import { styled } from 'dripsy';
import React from 'react';
import { View, ViewProps, ViewStyle } from 'react-native';

import { PaginationDot } from './PaginationDot';

const Container = styled(View)({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
});

const PaginationDotContainer = styled(View)({
  px: '$4',
});

export interface IPaginationProps extends Omit<ViewProps, 'style'> {
  dotsLength: number;
  activeDotIndex: number;
  containerStyle?: ViewStyle;
}

export function Pagination({
  dotsLength,
  activeDotIndex,
  containerStyle,
  ...props
}: IPaginationProps) {
  return (
    <Container style={containerStyle} {...props}>
      {Array.from({ length: dotsLength }).map((_, index) => (
        <PaginationDotContainer key={index}>
          <PaginationDot isActive={index === activeDotIndex} />
        </PaginationDotContainer>
      ))}
    </Container>
  );
}
